export const fetchRequest = (url, cb, onError) => {
  const data = url.data || {};
  return fetch(url.data ? url.url : url, data)
    .then(response => {
      if (response.status !== 200) {
        // console.log(`Problem. Status Code: ${response.status}`);
        return onError();
      }
      return response.json();
    })
    .then(
      response =>
        new Promise(resolve => {
          resolve(cb(response));
        })
    )
    .catch(error => {
      // console.log('Error!', err);
      if (onError) onError(error);
    });
};

export const buidlURL = (location, params) => {
  const url = new URL(location);

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      url.searchParams.append(key, params[key]);
    }
  }

  return encodeURI(url);
};

export const translit = str => {
  if (/[а-я]/i.test(str)) return str;
  // prettier-ignore
  const ru = {
      а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'j', з: 'z', и: 'i', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'c', ч: 'ch', ш: 'sh', щ: 'shch', ы: 'y', э: 'e', ю: 'u', я: 'ya'
    },
    n_str = [];
  str = str.replace(/[ъь]+/g, '').replace(/й/g, 'i');
  for (let i = 0; i < str.length; ++i) {
    n_str.push(
      ru[str[i]] ||
        (ru[str[i].toLowerCase()] == undefined && str[i]) ||
        ru[str[i].toLowerCase()].replace(/^(.)/, function(match) {
          return match.toUpperCase();
        })
    );
  }

  return n_str.join('');
};

export const GATEWAY = 'https://well.ru/local/modules/hotel.search/';
// export const GATEWAY = 'https://well.ru/local/modules/hotel.search.nightly/';

const pressed = [];
let lastID = 0;
export const invokeOnce = (callback, timeout) => {
  const localID = lastID++;
  pressed.push(localID);

  return setTimeout(() => {
    const localPressed = [...pressed];
    const go = localPressed.length === 1 && localPressed[0] === localID;
    pressed.splice(pressed.indexOf(localID), 1);
    return go ? callback() : false;
  }, timeout);
};

export const navigateWithPOST = (url, data) => {
  const form = document.createElement('form');
  form.style.visibility = 'hidden';
  form.method = 'POST';
  form.acceptCharset = 'Windows-1251';
  form.target = '_blank';
  form.action = url;
  for (const key in data) {
    const input = document.createElement('input');
    input.name = key;
    input.value = data[key];
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
  form.remove();
};

export const distance = (lat1, lon1, lat2, lon2) => {
  if (lat1 == lat2 && lon1 == lon2) {
    return 0;
  } else {
    const radlat1 = (Math.PI * lat1) / 180;
    const radlat2 = (Math.PI * lat2) / 180;
    const theta = lon1 - lon2;
    const radtheta = (Math.PI * theta) / 180;
    let dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1609.344;
    return parseInt(dist);
  }
};

export const calcPrice = rate =>
  rate ? (parseFloat(rate.payment_options.payment_types[0].amount) + 30) / (1 - 0.13) : 0;

export const scrollTo = (href) => {
    const subj = document.getElementById( href );
    subj.scrollIntoView({
      behavior: 'smooth',
    });
  };
  
export const i18n = {
  month: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ],
  day: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  errors: {
    'Access denied': 'Доступ запрещен',
    'Error getting Request Id': 'Поиск не удался, неверно заполнены поля',
    'No hotel photos': 'Фото отеля отсутствует',
    'No hotel details': 'Описание отеля отсутствует',
    'No hotels with tours': 'Нет отелей с турами по заданным параметрам'
  },
  loading: {
    Initialization: 'Инициализирую',
    'Getting countries': 'Открываю страны',
    Searching: 'Ищу туры',
    'Getting result': 'Загружаю туры',
    'Getting hotel info': 'Узнаю об отеле',
    'Actualizing tour': 'Уточняю актуальность тура',
    'Actualizing tour details': 'Уточняю цену за перелет',
    'Getting cheeper': 'Ищу дешевле'
  }
};
